<div class="vi-wrapper" 
      [style.width.px]="calcVideoWidth(videoWidth)" 
      [style.marginLeft]="videoWidth > 0 ? 'auto' : null" 
      [style.marginRight]="videoWidth > 0 ? 'auto' : null"
      >
  <!-- Dashed border box -->
  <div class="vi-box">

    <!-- Eye caret sits ON the top dashed border -->
    <div class="vi-eye-caret">
      <ion-icon name="eye-outline"></ion-icon>
    </div>

    <!-- Header row: TTS + title -->
    <div class="vi-header">
      <div class="vi-tts-wrap">
        <app-messagebubble [text]="ttsText"></app-messagebubble>
      </div>
      <span class="vi-title">{{ 'video_instructions.title' | translate }}</span>
    </div>

    <!-- Instruction lines -->
    <div class="vi-instructions">

      <div class="vi-row vi-row--plain">
        <span class="vi-text">{{ 'video_instructions.tap_arrow' | translate }}</span>
      </div>

      <div class="vi-row">
        <span class="vi-bullet-icon vi-arrows">
          <svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <polyline points="5,0.5 0.5,0.5 0.5,5" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
            <line x1="0.5" y1="0.5" x2="6" y2="6" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
            <polyline points="15,0.5 19.5,0.5 19.5,5" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
            <line x1="19.5" y1="0.5" x2="14" y2="6" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
            <polyline points="5,19.5 0.5,19.5 0.5,15" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
            <line x1="0.5" y1="19.5" x2="6" y2="14" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
            <polyline points="15,19.5 19.5,19.5 19.5,15" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
            <line x1="19.5" y1="19.5" x2="14" y2="14" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </span>
        <span class="vi-text">{{ 'video_instructions.full_screen' | translate }} <span class="vi-mobile-note">{{ 'video_instructions.mobile_only' | translate }}</span></span>
      </div>

      <div class="vi-row">
        <span class="vi-bullet-icon">
          <ion-icon name="settings-outline" style="font-size: 20px; color: #000;"></ion-icon>
        </span>
        <span class="vi-text">{{ 'video_instructions.change_language' | translate }}</span>
      </div>

      <div class="vi-row">
        <span class="vi-bullet-icon vi-speedo">
          <svg width="18" height="18" viewBox="8.5 3.75 47.5 47.5" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M49.4254 45.3597C50.0296 45.821 50.8972 45.7073 51.3216 45.0765C53.4438 41.922 54.7551 38.2839 55.1281 34.4859C55.5459 30.2303 54.7692 25.9425 52.8851 22.104C51.0011 18.2654 48.0842 15.0281 44.4621 12.7555C40.84 10.4829 36.6561 9.26499 32.3801 9.2386C28.1042 9.21221 23.9055 10.3783 20.2556 12.6061C16.6058 14.8338 13.6492 18.0349 11.7178 21.8499C9.78651 25.6649 8.95693 29.9428 9.32225 34.2032C9.6483 38.0055 10.9146 41.6595 12.9977 44.84C13.4143 45.4759 14.2804 45.6004 14.8903 45.1466C15.5002 44.6928 15.6223 43.8328 15.211 43.1935C13.4305 40.4262 12.3475 37.2602 12.0652 33.968C11.7436 30.2175 12.4738 26.4517 14.174 23.0933C15.8742 19.7349 18.4769 16.917 21.6899 14.9559C24.9029 12.9948 28.599 11.9683 32.3631 11.9915C36.1273 12.0148 39.8104 13.0869 42.999 15.0874C46.1875 17.088 48.7552 19.9379 50.4138 23.317C52.0724 26.6961 52.7561 30.4707 52.3883 34.2168C52.0653 37.5054 50.9433 40.6577 49.1288 43.4028C48.7096 44.037 48.8211 44.8984 49.4254 45.3597Z" fill="black" stroke="black"/>
            <line x1="34.146" y1="30.1188" x2="43.1188" y2="20.3303" stroke="black" stroke-width="3" stroke-linecap="round"/>
            <circle cx="32.7382" cy="31.7382" r="1.5" fill="black"/>
          </svg>
        </span>
        <span class="vi-text">{{ 'video_instructions.change_speed' | translate }}</span>
      </div>

      <div class="vi-row">
        <span class="vi-bullet-icon vi-cc">
          <span class="vi-cc-badge">cc</span>
        </span>
        <span class="vi-text">{{ 'video_instructions.subtitles' | translate }}</span>
      </div>

    </div>
  </div>
</div>
